export default __webpack_public_path__ + "static/media/highcharts.7909655f.svg";